class Subscription {
    constructor() {
        //订阅开关标识位
        this.closed = false;
    }
    unsubscribe() {
        if (this.closed)
            return;
        this.closed = true;
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }
    add(destroy) {
        this._unsubscribe = destroy; //->Base.stop
    }
}
//继承了 Subscription 类，并实现了 Observer 接口。Subscription 用于取消订阅，Observer 用于消费 Observable 的值
class Subscriber extends Subscription {
    constructor(observer) {
        super();
        //上传流程标识位
        this.isStopped = false;
        this.destination = observer;
    }
    unsubscribe() {
        this.isStopped = true;
        super.unsubscribe();
    }
    progress(value) {
        if (this.isStopped)
            return;
        if (this.destination.progress) {
            this.destination.progress(value);
        }
    }
    error(error) {
        if (this.isStopped)
            return;
        if (this.destination.error) {
            this.destination.error(error);
            this.isStopped = true;
        }
    }
    complete(result) {
        if (this.isStopped)
            return;
        if (this.destination.complete) {
            this.destination.complete(result);
            this.isStopped = true;
        }
    }
}
class Observable {
    constructor(_subscribe) {
        this._subscribe = _subscribe;
    }
    //订阅
    subscribe(observer) {
        const sink = new Subscriber(observer);
        sink.add(this._subscribe(sink));
        return sink;
    }
}

const MB = 1024 ** 2;
const GB = 1024 ** 3;
const DEFAULT_REQUEST_LIMIT = 3;
//默认分片单元大小，单位 MB
const DEFAULT_CHUNK_SIZE = 10;
function createXHR() {
    if (window.XMLHttpRequest) {
        return new XMLHttpRequest();
    }
    // @ts-ignore
    if (window.ActiveXObject) {
        // @ts-ignore
        return new window.ActiveXObject("Microsoft.XMLHTTP");
    }
    throw new Error("the current environment does not support.");
}
function request(url, options) {
    return new Promise((resolve, reject) => {
        const xhr = createXHR();
        xhr.open(options.method, url);
        if (options.onCreate) {
            options.onCreate(xhr);
        }
        if (options.headers) {
            const headers = options.headers;
            Object.keys(headers).forEach((k) => {
                xhr.setRequestHeader(k, headers[k]);
            });
        }
        xhr.upload.addEventListener("progress", (evt) => {
            if (evt.lengthComputable && options.onProgress) {
                options.onProgress({
                    loaded: evt.loaded,
                    total: evt.total,
                });
            }
        });
        xhr.onreadystatechange = () => {
            const responseText = xhr.responseText;
            if (xhr.readyState !== 4) {
                return;
            }
            const reqId = /* xhr.getResponseHeader("x-reqId") || */ "";
            if (xhr.status === 0) {
                // 发生 0 基本都是网络错误，常见的比如跨域、断网、host 解析失败、系统拦截等等
                reject(new Error(`${reqId} network error.`));
                return;
            }
            if (xhr.status !== 200) {
                let message = `xhr request failed, code: ${xhr.status}`;
                if (responseText) {
                    message += ` response: ${responseText}`;
                }
                // let data;
                // try {
                //   data = JSON.parse(responseText);
                // } catch {
                //   // 无需处理该错误、可能拿到非 json 格式的响应是预期的
                // }
                reject(new Error(`${reqId} ${message}`));
                return;
            }
            try {
                const response = JSON.parse(responseText);
                if (response.status.code == 200) {
                    resolve({
                        reqId,
                        data: response.data,
                    });
                }
                else {
                    reject(response.status);
                }
            }
            catch (error) {
                reject(error);
            }
        };
        xhr.send(options.body);
    });
}
//文件分块
function getChunks(file, chunkSize) {
    //转换为字节
    let chunkByteSize = chunkSize * MB;
    // 如果 chunkByteSize 比文件大，则直接取文件的大小
    if (chunkByteSize > file.size) {
        chunkByteSize = file.size;
    }
    else {
        // 因为最多 10000 chunk，所以如果 chunkSize 不符合则把每片 chunk 大小扩大两倍
        while (file.size > chunkByteSize * 10000) {
            chunkByteSize *= 2;
        }
    }
    const chunks = [];
    const count = Math.ceil(file.size / chunkByteSize);
    for (let i = 0; i < count; i++) {
        const chunk = file.slice(chunkByteSize * i, i === count - 1 ? file.size : chunkByteSize * (i + 1));
        chunks.push(chunk);
    }
    return chunks;
}

class Pool {
    constructor(runTask, limit) {
        this.runTask = runTask;
        this.limit = limit;
        this.queue = [];
        this.processing = [];
    }
    check() {
        const processingNum = this.processing.length;
        const availableNum = this.limit - processingNum;
        this.queue.slice(0, availableNum).forEach(item => this.run(item));
    }
    run(item) {
        this.queue = this.queue.filter(v => v !== item);
        this.processing.push(item);
        this.runTask(item.task).then(() => {
            this.processing = this.processing.filter(v => v !== item);
            item.resolve(); //当前分片完成上传
            this.check();
        }, error => item.reject(error));
    }
    enqueue(task) {
        return new Promise((resolve, reject) => {
            this.queue.push({
                task,
                resolve,
                reject,
            });
            this.check();
        });
    }
}

//文件直传接口
function direct(url, data, options) {
    return request(url, Object.assign(Object.assign({}, options), { method: "POST", body: data }));
}
//分片上传准备
function uploadPrepare(url, options) {
    return request(url, Object.assign(Object.assign({}, options), { method: "POST" }));
}
//分片上传接口
function uploadChunk(url, options) {
    return request(url, Object.assign(Object.assign({}, options), { method: "PUT" }));
}
//分片合并接口
function uploadComplete(url, options) {
    return request(url, Object.assign(Object.assign({}, options), { method: "POST" }));
}
//分片合并接口
function getMkFileState(url, options) {
    return request(url, Object.assign(Object.assign({}, options), { method: "GET" }));
}

class Base {
    constructor(options, handlers) {
        this.aborted = false;
        this.xhrList = [];
        this.file = options.file;
        this.key = options.key;
        this.config = options.config;
        this.onProgress = handlers.onProgress;
        this.onError = handlers.onError;
        this.onComplete = handlers.onComplete;
    }
    clear() {
        this.xhrList.forEach((xhr) => {
            xhr.onreadystatechange = null;
            xhr.abort();
        });
        this.xhrList = [];
    }
    async putFile() {
        this.aborted = false;
        this.fname = this.file.name;
        if (this.file.size > 10000 * GB) {
            this.onError({
                //file error
                code: 1002,
                message: "file size exceed maximum value 10000G",
            });
        }
        try {
            const result = await this.run();
            //result: { reqId, data }
            this.onComplete(result.data);
            return;
        }
        catch (error) {
            this.clear();
            this.onError(error);
        }
    }
    stop() {
        this.clear();
        this.aborted = true;
    }
    addXhr(xhr) {
        this.xhrList.push(xhr);
    }
    getProgressInfoItem(loaded, size, fromCache) {
        return Object.assign({ size,
            loaded, percent: (loaded / size) * 100 }, (fromCache == null ? {} : { fromCache }));
    }
}

class Direct extends Base {
    async run() {
        const { accessToken, clientId, token, uploadHost } = this.config;
        const formData = new FormData();
        formData.append("file", this.file);
        //formData.append("key", this.key);
        //formData.append("token", this.token);
        formData.append("fname", this.fname);
        const url = `${uploadHost}/asset-center/front/asset/common/upload`;
        const result = await direct(url, formData, {
            headers: {
                "X-DT-accessToken": accessToken,
                "X-DT-clientId": clientId,
                "X-DT-uploadToken": token,
            },
            onProgress: (data) => {
                this.updateDirectProgress(data.loaded, data.total);
            },
            onCreate: (xhr) => this.addXhr(xhr),
        });
        this.finishDirectProgress();
        return result;
    }
    updateDirectProgress(loaded, total) {
        // 当请求未完成时可能进度会达到100，所以total + 1来防止这种情况出现
        const progressTotal = this.getProgressInfoItem(loaded, total + 1);
        this.progress = { total: progressTotal };
        this.onProgress(this.progress);
    }
    finishDirectProgress() {
        if (this.progress) {
            const { total } = this.progress;
            this.progress = {
                total: this.getProgressInfoItem(total.loaded + 1, total.size),
            };
            this.onProgress(this.progress);
        }
        //在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null，这里 fake 下
        this.progress = {
            total: this.getProgressInfoItem(this.file.size, this.file.size),
        };
        this.onProgress(this.progress);
    }
}

class Resume extends Base {
    async initBeforeUploadChunks() {
        this.uploadedList = [];
        //getUploadId
        const url = `${this.uploadHost}/asset-center/front/asset/chunkUpload/prepare`;
        const md5 = this.key;
        const response = await uploadPrepare(url, {
            headers: Object.assign(Object.assign({}, this.headers), { "content-type": "application/json" }),
            body: JSON.stringify({
                size: this.file.size,
                md5,
            }),
        });
        this.uploadId = response.data.uploadId;
        //init
        this.chunks = getChunks(this.file, DEFAULT_CHUNK_SIZE);
        this.loaded = {
            mkFileProgress: 0,
            chunks: this.chunks.map((_) => 0),
        };
        //this.notifyResumeProgress();
    }
    async uploadChunk(chunkInfo) {
        const { chunk, index } = chunkInfo;
        // const reuseSaved = () => {
        //   this.updateChunkUploadProgress(chunk.size, index);
        // };
        const url = `${this.uploadHost}/asset-center/front/asset/chunkUpload/${this.uploadId}/${index + 1}`;
        const response = await uploadChunk(url, {
            body: chunk,
            headers: Object.assign(Object.assign({}, this.headers), { "content-type": "application/octet-stream" }),
            onProgress: (data) => {
                this.updateChunkUploadProgress(data.loaded, index);
            },
            onCreate: (xhr) => this.addXhr(xhr),
        });
        //在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null，这里在每次分片上传完成后都手动更新下 progress
        this.updateChunkUploadProgress(chunk.size, index);
        this.uploadedList[index] = {
            etag: response.data.etag,
            md5: response.data.md5,
            size: chunk.size,
        };
    }
    async mkFileReq() {
        const data = {
            fname: this.fname,
            parts: this.uploadedList.map((value, index) => ({
                etag: value.etag,
                partNumber: index + 1,
            })),
        };
        const url = `${this.uploadHost}/asset-center/front/asset/chunkUpload/${this.uploadId}/merge`;
        await uploadComplete(url, {
            headers: Object.assign(Object.assign({}, this.headers), { "content-type": "application/json" }),
            body: JSON.stringify(data),
            onCreate: (xhr) => this.addXhr(xhr),
        });
        //Polling is very poor programming...
        const response = await this.checkMkFileStatus(100);
        this.updateMkFileProgress(1);
        return response;
    }
    async checkMkFileStatus(times) {
        const url = `${this.uploadHost}/asset-center/front/asset/chunkUpload/checkMergeStatus?uploadId=${this.uploadId}`;
        const response = await getMkFileState(url, {
            headers: Object.assign({}, this.headers),
            onCreate: (xhr) => this.addXhr(xhr),
        });
        // 0.未完成 1.已完成 2 合并异常
        const status = response.data.status;
        if (status == 1) {
            return response;
        }
        else if (status == 0 && times) {
            await new Promise((resolve) => setTimeout(resolve, 3000));
            return await this.checkMkFileStatus(--times);
        }
        else {
            throw new Error("the exception occurs when the server timeout for merging chunks.");
        }
    }
    updateChunkUploadProgress(loaded, index) {
        this.loaded.chunks[index] = loaded;
        this.notifyResumeProgress();
    }
    updateMkFileProgress(progress) {
        this.loaded.mkFileProgress = progress;
        this.notifyResumeProgress();
    }
    notifyResumeProgress() {
        const chunksLoaded = this.loaded.chunks.reduce((t, n) => t + n, 0);
        const loaded = chunksLoaded + this.loaded.mkFileProgress;
        const size = this.file.size + 1;
        this.onProgress({
            total: this.getProgressInfoItem(loaded, size),
            //chunks: [],
        });
    }
    //实现了 Base 的 run 接口，处理具体的分片上传事务，并抛出过程中的异常。
    async run() {
        const { accessToken, clientId, token, uploadHost } = this.config;
        this.uploadHost = uploadHost;
        this.headers = {
            "X-DT-accessToken": accessToken,
            "X-DT-clientId": clientId,
            "X-DT-uploadToken": token,
        };
        await this.initBeforeUploadChunks();
        const pool = new Pool((chunkInfo) => this.uploadChunk(chunkInfo), DEFAULT_REQUEST_LIMIT);
        let mkFileResponse;
        //const localKey = this.getLocalKey();
        const uploadChunks = this.chunks.map((chunk, index) => pool.enqueue({ chunk, index }));
        try {
            await Promise.all(uploadChunks); //所有分片完成上传
            mkFileResponse = await this.mkFileReq();
        }
        catch (error) {
            //removeLocalFileInfo(localKey);
            throw error;
        }
        //removeLocalFileInfo(localKey);
        return mkFileResponse;
    }
}

function createUploadManager(options, handlers) {
    //采用分片上传策略
    if (options.file.size > 10 * MB) {
        return new Resume(options, handlers);
    }
    //否则，直传
    return new Direct(options, handlers);
}
/**
 *
 * @param file 上传文件
 * @param key 目标文件名
 */
function upload(file, key, config) {
    return new Observable((observer) => {
        const manager = createUploadManager({
            file,
            key,
            config,
        }, {
            onProgress: (data) => observer.progress(data),
            onError: (error) => observer.error(error),
            onComplete: (res) => observer.complete(res),
        });
        manager.putFile();
        return manager.stop.bind(manager);
    });
}

export { upload };
